<rk-planning-header
  [calendarDatesChanged]="calendarDatesChanged | async"
  (addSlot)="slotCreation(null)"
  (dateSelectDatesChanged)="dateSelectDatesChanged($event)"
  (calendarPrevious)="calendarPrevious()"
  (calendarNext)="calendarNext()"
  (calendarToday)="calendarToday()"
></rk-planning-header>

<div class="planning-shell--card" [class.tiny-header]="$tinyHeader()">
  @if (radioTz$ | async) {
    <rk-mobile-calendar-header
      class="block md:hidden"
      [tinyHeader]="$tinyHeader()"
      [currentDay$]="currentDay$"
      [datesRange$]="datesRange$"
      (setCurrentDay)="setCurrentDay($event)"
      (unTinyHeader)="onUnTinyHeader()"
    ></rk-mobile-calendar-header>
  }
  <full-calendar
    #calendar
    class="planning-shell--calendar pl-4.5 md:pl-0"
    [ngClass]="{
      'fc-smooth-scrolling': smoothScrolling,
    }"
    [options]="calendarOptions"
  ></full-calendar>
  <div class="fc-custom-now-indicator absolute z-100 hidden"></div>
</div>

<rk-mobile-fab-button (click)="slotCreation(null)"></rk-mobile-fab-button>

<ng-template #dayHeaderContentContainer></ng-template>
